import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

/**
 * API Request
 */
export const searchProducts = (query) => {
  return axios.get(`/products/search`, {
    params: { q: query },
  });
};

/**
 * Hook
 */
export const useProductSearch = ({ query, config } = {}) => {
  return useQuery({
    ...config,
    enabled: Boolean(query && query.length > 1),
    queryKey: ['product-search', query],
    queryFn: () => searchProducts(query),
  });
};
